export default __webpack_public_path__ + "static/media/arrow_down.efd70681.svg";